export const CONFIG_PARAM_CAR = 'car'
export const CONFIG_PARAM_COLOR = 'color'
export const CONFIG_PARAM_UPHOLSTERY = 'upholstery'
export const CONFIG_PARAM_WHEEL = 'wheel'
export const CONFIG_PARAM_PACKS = 'packs'

export const SELECTION_PARAM_WALLBOX = 'wallbox-selected'
export const SELECTION_PARAM_INSURANCE = 'insurance-selected'
export const SELECTION_PARAM_INSURANCE_QUOTE = 'insurance-quote'
export const SELECTION_PARAM_TRADE_IN = 'trade-in'
